/* eslint-disable no-magic-numbers */

import { differenceInDays } from 'date-fns';

/**
 * Returns the forecast duration in years based on the forecast kind
 * @param forecastKind - Forecast kind
 */
export const getForecastKindDuration = (forecastKind: string) => {
  switch (forecastKind) {
    case 'budget':
      return 1;
    default:
      return 3;
  }
};

/**
 * Returns the period count (in days) for the given forecast start date and duration
 * @param forecastFromDate - Forecast start date (as string YYYY-MM-DD)
 * @param forecastDuration - Forecast duration (in years)
 */
export const getForecastPeriodCount = (forecastFromDate: string, forecastDuration: number) => {
  const startDate = new Date(forecastFromDate);
  const endDate = new Date(forecastFromDate);
  endDate.setFullYear(endDate.getFullYear() + forecastDuration);
  return differenceInDays(endDate, startDate);
};
